var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CycleProductCard',{attrs:{"heading":_vm.heading,"icon":_vm.icon,"bodytext":_vm.bodytext,"button-list":_vm.buttonList}})
}
var staticRenderFns = []

export { render, staticRenderFns }